import Icon from '../components/Icon.vue'

Icon.register({
  th: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M149.3 56V136C149.3 149.3 138.6 160 125.3 160H24C10.7 160 0 149.3 0 136V56C0 42.7 10.7 32 24 32H125.3C138.6 32 149.3 42.7 149.3 56zM330.7 296V216C330.7 202.7 319.9 192 306.7 192H205.3C192.1 192 181.3 202.7 181.3 216V296C181.3 309.3 192.1 320 205.3 320H306.7C319.9 320 330.7 309.3 330.7 296zM362.7 56V136C362.7 149.3 373.4 160 386.7 160H488C501.3 160 512 149.3 512 136V56C512 42.7 501.3 32 488 32H386.7C373.4 32 362.7 42.7 362.7 56zM330.7 136V56C330.7 42.7 319.9 32 306.7 32H205.3C192.1 32 181.3 42.7 181.3 56V136C181.3 149.3 192.1 160 205.3 160H306.7C319.9 160 330.7 149.3 330.7 136zM125.3 192H24C10.7 192 0 202.7 0 216V296C0 309.3 10.7 320 24 320H125.3C138.6 320 149.3 309.3 149.3 296V216C149.3 202.7 138.6 192 125.3 192zM0 376V456C0 469.3 10.7 480 24 480H125.3C138.6 480 149.3 469.3 149.3 456V376C149.3 362.7 138.6 352 125.3 352H24C10.7 352 0 362.7 0 376zM386.7 320H488C501.3 320 512 309.3 512 296V216C512 202.7 501.3 192 488 192H386.7C373.4 192 362.7 202.7 362.7 216V296C362.7 309.3 373.4 320 386.7 320zM386.7 480H488C501.3 480 512 469.3 512 456V376C512 362.7 501.3 352 488 352H386.7C373.4 352 362.7 362.7 362.7 376V456C362.7 469.3 373.4 480 386.7 480zM181.3 376V456C181.3 469.3 192.1 480 205.3 480H306.7C319.9 480 330.7 469.3 330.7 456V376C330.7 362.7 319.9 352 306.7 352H205.3C192.1 352 181.3 362.7 181.3 376z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/th.js
// module id = /ZRq
// module chunks = 144